import { render, staticRenderFns } from "./PostcodePopComp.vue?vue&type=template&id=76faa2d5"
import script from "./PostcodePopComp.vue?vue&type=script&lang=js"
export * from "./PostcodePopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports